import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da0a05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-my-4 p-text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "คืนสินค้า/คืนเงิน")
], -1))
const _hoisted_2 = { class: "return-2-panel p-mx-2" }
const _hoisted_3 = { class: "border-bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "p-p-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" หมายเลขการติดตามผล : "),
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "RET20200401")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("สถานะ: "),
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "รอการพิจารณา")
], -1))
const _hoisted_8 = { class: "p-text-center p-p-3" }
const _hoisted_9 = { class: "p-my-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mb-5" }, " สำหรับการคืนสินค้า กรุณาระบุหมายเลขการคืน/เปลี่ยนสินค้าทุกครั้ง หรือสามารถดาวน์โหลดใบคืนของและพิมพ์ใส่ในกล่องคืนสินค้า ", -1))
const _hoisted_11 = { class: "p-mt-4 p-text-center p-mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ReturnRepuestForm = _resolveComponent("ReturnRepuestForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.sumaryState == 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createElementVNode("u", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSummaryState(2)))
                  }, "ดูรายละเอียด")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  label: "ดาวน์โหลดใบส่งคืนสินค้า",
                  class: "p-button-outlined p-button-danger"
                })
              ]),
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              label: "ทำรายการต่อ",
              class: "p-button-danger w-100",
              onClick: _ctx.onSetReturnState
            }, null, 8, ["onClick"])
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_ReturnRepuestForm, {
          key: 1,
          isDisplay: true
        }))
  ]))
}